import { plural, t } from '@lingui/core/macro'

/**
 * Formats duration in seconds to a readable format
 * < 1min: seconds (e.g. "5 sec", "45 sec")
 * < 1h: minutes (e.g. "5 min", "45 min")
 * < 24h: hours (e.g. "2h", "2h 30m")
 * >= 24h: days (e.g. "2 days", "1 day")
 */
export function formatDuration(seconds) {
  if (!seconds || seconds < 0) {
    return t`0 sec`
  }

  // Truncated, not rounded: mirrors `seconds.to_i` in format_duration (metrics_helper.rb),
  // so the same average never renders as "59 sec" server-side and "60 sec" here.
  const s = Math.trunc(seconds)

  // Less than 1 minute - show in seconds
  if (s < 60) {
    return t`${s} sec`
  }

  // Less than 1 hour - show in minutes
  if (s < 3600) {
    const minutes = Math.round(s / 60)
    return t`${minutes} min`
  }

  // Less than 24 hours - show in hours and minutes
  if (s < 86400) {
    const hours = Math.floor(s / 3600)
    const minutes = Math.round((s % 3600) / 60)

    if (minutes === 0) {
      return t`${hours}h`
    }
    return t`${hours}h ${minutes}m`
  }

  // 24 hours or more - show in days
  const days = Math.round(s / 86400)
  return plural(days, {
    one: '# day',
    other: '# days',
  })
}
